import { render } from "./MatchTableResult.vue?vue&type=template&id=69af2c9e&scoped=true"
import script from "./MatchTableResult.vue?vue&type=script&lang=js"
export * from "./MatchTableResult.vue?vue&type=script&lang=js"

import "./MatchTableResult.vue?vue&type=style&index=0&id=69af2c9e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69af2c9e"]])

export default __exports__